import { render, staticRenderFns } from "./rightPage.vue?vue&type=template&id=af4a66ac&scoped=true&"
import script from "./rightPage.vue?vue&type=script&lang=js&"
export * from "./rightPage.vue?vue&type=script&lang=js&"
import style0 from "./rightPage.vue?vue&type=style&index=0&id=af4a66ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4a66ac",
  null
  
)

export default component.exports